export default __webpack_public_path__ + "static/autism-connect-xl-72200e944d3622cbb8bd1cb0600929a3.svg";